
import { useState, useEffect } from "react";

export interface WorksheetFilters {
  searchQuery: string;
  sortField: string;
  sortDirection: "asc" | "desc";
  subjectFilter: string;
}

export const useWorksheetFilters = (subjects: string[]) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sortField, setSortField] = useState<string>("created_at");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");
  const [subjectFilter, setSubjectFilter] = useState<string>("all");
  
  // Handle sort changes
  const handleSort = (field: string) => {
    if (field === sortField) {
      // Toggle direction if clicking on the same field
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // New field, default to ascending
      setSortField(field);
      setSortDirection("asc");
    }
  };

  // Reset page when filters change
  useEffect(() => {
    // This effect will be used in the parent hook to reset pagination
  }, [searchQuery, subjectFilter]);

  return {
    searchQuery,
    setSearchQuery,
    sortField,
    sortDirection,
    handleSort,
    subjectFilter,
    setSubjectFilter,
    subjects
  };
};
